import * as yup from 'yup';
import { slackLinkSchema } from '../../form/schema-utils';
import {
  addOptionalNullableToSchema,
  emailSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
} from '@common/schema';

export const generalSchema = yup.object().shape({
  first_name: requiredNameSchema,
  last_name: requiredNameSchema,
  suffix: yup.string(),
  external: yup.boolean().required(requiredErrorMessage),
  partner_id: yup.string().required(requiredErrorMessage),
  practice_id: yup.string().required(requiredErrorMessage),
  email: addOptionalNullableToSchema(emailSchema),
  phone_number: addOptionalNullableToSchema(phoneSchema),
  provider_specialty: yup.string().required(requiredErrorMessage),
  slack_link: slackLinkSchema,
  inactive: yup.boolean().required(),
  region_id: yup.string().nullable().optional(),
  clinical_leader_id: yup.string().nullable().optional(),
  supervising_physician_id: yup.string().nullable().optional(),
});
